import React from 'react'
import { Route, BrowserRouter as Router, Routes, Link, NavLink, useParams  } from 'react-router-dom';
import config from '../Config';

export const NotfoundSec = () => {
  return (
    <>
    <div id="notfound">
            <div className="notfound">
                <div className="notfound-404">
                    <div className="notfound-wrap">
                        <h2><img src={`${config.siteBaseUrl}/assets/imgs/404.svg`} alt="404" /></h2>
                    </div>
                </div>

                <div className="page-not-found">
                    <div className="notfound-wrap">
                        <h2>Sorry, Page Not Found</h2>
                        <p>The page you requested could not be found.</p>
                        <Link to="">Go Back</Link>
                    </div>
                </div>
            </div>
    </div>
    </>
  )
}
